import  gql  from 'graphql-tag'

export const CREATE_CATALOG_SALE_PERCENT = gql`mutation catalogSalePercent($input: CatalogSalePercentMutationInput!){
    catalogSalePercent(input: $input){
        catalogSalePercent{
            id
            percent
        }
        errors{
            field
            messages
        }
    }
}`;